module.exports = __webpack_public_path__ + "img/filter.954e720c.svg";